
import { supabase } from "@/integrations/supabase/client";

export const getTestByLevelAndCategory = async (age: string, category: string, level: string) => {
  console.log("Searching for test with params:", { age, category, level });
  
  const { data, error } = await supabase
    .from("tests")
    .select("*")
    .eq("grade_level", age)
    .eq("category", category)
    .eq("title", level)
    .maybeSingle();

  if (error) {
    console.error("Error fetching test:", error);
    throw error;
  }

  console.log("Test search result:", data);
  return data;
};

export const getLevelsForAgeAndCategory = (tests: any[] | undefined, age: string, category: string) => {
  if (!tests) {
    console.log("No tests available");
    return [];
  }
  
  console.log("Filtering tests for:", { age, category });
  console.log("Available tests:", tests);
  
  const ageTests = tests.filter(test => {
    const matches = test.grade_level === age && test.category === category;
    console.log("Test", test.id, "matches?", matches, {
      testAge: test.grade_level,
      testCategory: test.category,
      expectedAge: age,
      expectedCategory: category
    });
    return matches;
  });

  console.log("Filtered tests for age and category:", ageTests);

  return ageTests.map(test => ({
    name: test.title,
    difficulty: test.difficulty,
    title: test.title,
    id: test.id,
    className: "bg-gray-50 hover:bg-gray-100"
  }));
};
